import { useEffect, useRef, useState } from "react";

// Chrome dot + ring cursor. Desktop / fine-pointer only.
export default function CustomCursor() {
  const dot = useRef(null);
  const ring = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    if (!fine) return;
    setEnabled(true);
    document.documentElement.classList.add("cursor-hidden");

    let mx = window.innerWidth / 2, my = window.innerHeight / 2;
    let rx = mx, ry = my;
    let raf;

    const move = (e) => {
      mx = e.clientX;
      my = e.clientY;
      if (dot.current) {
        dot.current.style.transform = `translate3d(${mx}px, ${my}px, 0) translate(-50%, -50%)`;
      }
      const t = e.target;
      const interactive = t.closest("a, button, [data-cursor], input, [role='button']");
      if (ring.current) {
        ring.current.dataset.active = interactive ? "1" : "0";
      }
    };
    const loop = () => {
      rx += (mx - rx) * 0.16;
      ry += (my - ry) * 0.16;
      if (ring.current) {
        ring.current.style.transform = `translate3d(${rx}px, ${ry}px, 0) translate(-50%, -50%)`;
      }
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("mousemove", move);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", move);
      cancelAnimationFrame(raf);
      document.documentElement.classList.remove("cursor-hidden");
    };
  }, []);

  if (!enabled) return null;
  return (
    <>
      <div
        ref={dot}
        className="fixed top-0 left-0 z-[10000] pointer-events-none w-1.5 h-1.5 rounded-full bg-white mix-blend-difference"
      />
      <div
        ref={ring}
        data-active="0"
        className="fixed top-0 left-0 z-[9999] pointer-events-none rounded-full border border-white/60 mix-blend-difference transition-[width,height,opacity] duration-300 ease-out data-[active=1]:w-14 data-[active=1]:h-14 data-[active=0]:w-8 data-[active=0]:h-8"
        style={{ width: 32, height: 32 }}
      />
    </>
  );
}
